<template>
  <div role="group" class="quantity-selector-incremental" data-qty-incremental>
    <button type="button" @click="updateQuantity(-1)">-</button>
    <input disabled type="text" :value="quantity" />
    <button type="button" @click="updateQuantity(1)">+</button>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'quantity',
    event: 'change'
  },
  props: {
    quantity: {
      type: Number,
      required: true
    },
    inventoryQuantity: {
      type: Number,
      default: 10
    }
  },

  methods: {
    updateQuantity(increment) {
      const newVal = this.quantity + increment;

      if (newVal > 0 && newVal <= this.inventoryQuantity) {
        this.$emit('change', newVal);
      }
    }
  }
};
</script>
